import { Spin } from 'antd';
import './app-loader.scss';

/**
 * App Loader Component
 *
 * Displays a full-screen overlay with a loading spinner.
 *
 * @param {Object} props - Component properties
 * @param {boolean} props.visible - Whether to show the overlay
 * @param {'small' | 'default' | 'large'} [props.spinnerSize='large'] - Ant Design Spin size
 * @param {Object} [props.spinnerStyle={}] - Additional CSS styles for the spinner
 * @param {string} [props.backgroundColor='rgba(255,255,255,0.6)'] - Background overlay color
 * @param {number} [props.zIndex=2] - CSS z-index of the overlay
 *
 * @example
 * <AppLoader
 *   visible={loading}
 *   spinnerSize="default"
 *   spinnerStyle={{ color: 'red' }}
 *   backgroundColor=""
 *   zIndex={5}
 * />
 */

export default function AppLoader({ visible, spinnerSize = 'large', spinnerStyle = {}, backgroundColor = 'rgba(255,255,255,0.6)', zIndex = 2 }) {
    if (!visible) return null;

    return (
        <div className="loader-overlay" style={{ background: backgroundColor, zIndex }}>
            <Spin size={spinnerSize} style={spinnerStyle} />
        </div>
    );
}
